export default __webpack_public_path__ + "static/media/19-shades.90a33bf0.png";